import FollowerPie from "./follower-pie";

export default FollowerPie;